import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useI18n } from "../i18n";
import { Arrow } from "./Brand";

export function SectionHeading({
  eyebrow,
  title,
  description,
  inverse = false,
}: {
  eyebrow: string;
  title: ReactNode;
  description?: string;
  inverse?: boolean;
}) {
  return (
    <div
      className={`section-heading ${inverse ? "section-heading--inverse" : ""}`}
    >
      <p className="section-label">{eyebrow}</p>
      <div className="section-heading__body">
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
}

export function PageHero({
  eyebrow,
  title,
  lead,
  aside,
  className = "",
}: {
  eyebrow: string;
  title: ReactNode;
  lead: string;
  aside?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`page-hero ${className}`}>
      <div className="container">
        <p className="page-hero__label">{eyebrow}</p>
        <div className="page-hero__grid">
          <h1>{title}</h1>
          <div className="page-hero__lead">
            <p>{lead}</p>
            {aside}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  const { l } = useI18n();
  return (
    <section className="cta-section">
      <div className="container cta-section__inner">
        <div className="cta-section__body">
          <h2>
            {l("把一个想法，做成", "Turn an idea into")}
            <br />
            {l("可以工作的产品。", "a product that works.")}
          </h2>
          <Link className="button button--light" to="/contact">
            {l("告诉我们你的想法", "Share your idea")}{" "}
            <Arrow direction="up-right" />
          </Link>
        </div>
        <div className="cta-section__signal" aria-hidden="true">
          {Array.from({ length: 18 }, (_, index) => (
            <i key={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function TagList({ tags }: { tags: string[] }) {
  return (
    <div className="tag-list">
      {tags.map((tag) => (
        <span key={tag}>{tag}</span>
      ))}
    </div>
  );
}
